import { render, staticRenderFns } from "./Security_Permission.vue?vue&type=template&id=6a50207a&scoped=true&"
import script from "./Security_Permission.vue?vue&type=script&lang=js&"
export * from "./Security_Permission.vue?vue&type=script&lang=js&"
import style0 from "./Security_Permission.vue?vue&type=style&index=0&id=6a50207a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a50207a",
  null
  
)

export default component.exports